import * as React from "react";
function SvgHandshake(props, svgRef) {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={svgRef}
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M17.95 4.222l-1.415-1.414a2 2 0 00-2.828 0l-2.815 2.814L8.877 3.53l-.706-.735-.721.72-5.657 5.658-.697.697.687.707 3.652 3.755a3.4 3.4 0 00.777 3.609l2.262 2.263a3.4 3.4 0 003.674.75 4.001 4.001 0 005.095-.468l.707-.707.707-.707a4.002 4.002 0 00.618-4.86l3.624-3.625.707-.707-.707-.707-4.95-4.95zm-4.19 15.326a2 2 0 002.068-.477l.707-.707.708-.707a2 2 0 000-2.828l-3.536-3.536-1.414 1.414-.707.707-.708-.707-2.12-2.121a2 2 0 010-2.829l.72-.72L8.143 5.65 3.904 9.889l2.786 2.864a2.6 2.6 0 013.199.379l3.394 3.394c.818.817.977 2.044.477 3.022zm4.19-6.84l-2.829-2.83.707-.706-1.414-1.415-2.829 2.829-1.414-1.414 1.415-1.415 3.535-3.535 1.414 1.414 4.243 4.243-2.828 2.828zM7.626 14.545a.6.6 0 01.848 0l3.395 3.394a.6.6 0 010 .848 1.4 1.4 0 01-1.98 0l-2.263-2.262a1.4 1.4 0 010-1.98z"
                fill="currentcolor"
            />
        </svg>
    );
}
const ForwardRef = React.forwardRef(SvgHandshake);
export default ForwardRef;
